import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CheckDigitalProfile, CheckDigitalProfileFound, CheckDigitalProfileNotFound, CreateProfileProductTypeSuccess, GetPhoneByWalletIdFound, GetPhoneByWalletIdNotFound, RegisterNewProfile, RegisterNewProfileSuccess, SetWalletId, UpdateProfileProductType, UpdateProfileProductTypeSuccess } from "./auth.actions";
import { catchError, map, mergeMap, of } from "rxjs";
import { SignInService } from "src/app/services/sign-in.service";
import { GetPhoneByWalletIdResponse, RiskStatus } from "./auth.model";
import { createInternationalPhoneNumber } from "src/app/feature/sign-in/utils/phone-utils";
import { CheckDigitalProfileResponse, ProfileDetails, RegisterNewProfileResponse, UserPhoneDetails } from "src/app/models/sign-in.models";

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private signInService: SignInService
  ) {}

  public getPhoneByWalletId$ = createEffect(() => 
    this.actions$.pipe(
      ofType(SetWalletId),
      mergeMap(({walletId}) => {
        return this.signInService.getPhoneByWallet(walletId).pipe(
          map((res: GetPhoneByWalletIdResponse) => {
            if (res?.consumer ?? false) {
              const { countryDialCode, number } = res.consumer.mobilePhone;
              const { digitalProfileId } = res;
              // Todo: Tim: #may6 - revisit this, there may be a better way to capture riskStatus attributes
              let riskStatus: RiskStatus | null;
              if (res.hasOwnProperty('isStepUpRequired') && res.hasOwnProperty("isRedirectRequired")) {
                riskStatus = {
                  isStepUpRequired: res.isStepUpRequired,
                  isRedirectRequired: res.isRedirectRequired,
                  compliancePayload: res.compliancePayload,
                  profileVerification: res.profileVerification
                }
              }
              else {
                riskStatus = null
              }
              const phoneDetails = this.generateUserPhoneDetails(countryDialCode, number)
              return GetPhoneByWalletIdFound({phoneDetails, digitalProfileId, riskStatus})
            }
            else {
              return GetPhoneByWalletIdNotFound()
            }
          }),
          // catchError((error) => { // Todo: Tim: add error handling #may6
          //   return
          // })
        )
      })
    )
  )

  public checkDigitalProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CheckDigitalProfile
      ),
      mergeMap(({phoneNumber, countryDialCode}) => { // Todo: Tim: #may6 fix type
        return this.signInService.checkDigitalProfile(phoneNumber, countryDialCode).pipe(
          map((res: CheckDigitalProfileResponse) => {
            if (res?.digitalProfileId && res.digitalProfileId !== undefined) {
              return CheckDigitalProfileFound(res);
            }
            else {
              return CheckDigitalProfileNotFound(res);
            }
          }),
          // catchError((error) => { // Todo: Tim: add error handling #may6
          //   return
          // })
        )
      })
    )
  )

  public createProfileProductType$ = createEffect(() => 
    this.actions$.pipe(
      ofType(
        RegisterNewProfileSuccess
      ),
      mergeMap(({ res, walletId, fbAuthToken }) => {
        return this.signInService.updateProfileProductType(res.digitalProfileId, walletId, fbAuthToken).pipe(
          map((res: any) => {
            return CreateProfileProductTypeSuccess();
          })
          // catchError((error) => { // Todo: Tim: add error handling #may6
          //   return
          // })
        )
      })
    ),
  )

  public updateProfileProductType$ = createEffect(() => 
    this.actions$.pipe(
      ofType(
        UpdateProfileProductType
      ),
      mergeMap(({ dpid, walletId, fbAuthToken }) => {
        return this.signInService.updateProfileProductType(dpid, walletId, fbAuthToken).pipe(
          map((res: any) => {
            return UpdateProfileProductTypeSuccess();
          })
          // catchError((error) => { // Todo: Tim: add error handling #may6
          //   return
          // })
        )
      })
    ),
  )

  public registerNewProfile$ = createEffect(() => 
    this.actions$.pipe(
      ofType(
        RegisterNewProfile
      ),
      mergeMap((profilePayload: ProfileDetails) => {
        return this.signInService.registerNewProfile(profilePayload).pipe(
          map((res: RegisterNewProfileResponse) => {
              const fbAuthToken = profilePayload.fbAuthToken
              let riskStatus: RiskStatus
              riskStatus = {
                isStepUpRequired: res.isStepUpRequired,
                isRedirectRequired: res.isRedirectRequired ?? true,
                compliancePayload: res.compliancePayload,
                profileVerification: res.profileVerification
              }
            return RegisterNewProfileSuccess({ res, riskStatus, walletId: profilePayload.walletId, fbAuthToken});
          }),
          // catchError((error) => { // Todo: Tim: add error handling #may6
          //   return
          // })
        )
      })
    )
  )

  private generateUserPhoneDetails(countryDialCode: string, phoneNumber: string): UserPhoneDetails {
    const internationalPhoneNumber = createInternationalPhoneNumber(countryDialCode, phoneNumber);
    const phoneDetails = {
      phoneNumber,
      countryDialCode,
      internationalPhoneNumber
    }
    return phoneDetails;
  }
}